var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['timer', _vm.remainingColorClass, _vm.expiredClass]},[_vm._v(" "+_vm._s(_vm.$t("time_to_done", { seconds: _vm.timerSeconds }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }